<ng-container>
  <kendo-floatinglabel [text]="label" class="autocomplete-wrapper">
    <kendo-combobox
      #autocomplete
      class="autocomplete"
      [formControl]="control"
      [loading]="query.loading"
      [filterable]="true"
      (filterChange)="handleFilter($event)"
      [data]="query | async"
      [valueField]="'name'"
      [textField]="'name'"
      [valueNormalizer]="valueNormalizer"
      [allowCustom]="true"
    >
      <ng-template kendoComboBoxItemTemplate let-dataItem>
        {{ dataItem.name }}
      </ng-template>
    </kendo-combobox>
  </kendo-floatinglabel>
</ng-container>
